import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock'

export default class Header {
	constructor(el) {
		el = el || document.querySelector('#header')
		if (!el) return

		this.e = el
		this.t = el.querySelector('.toggle')

		if (this.t) this.t.onclick = this.toggle.bind(this)
		window.addEventListener('scroll', this.scroll.bind(this))
	}

	toggle() {
		this.e.classList.toggle('open')
		this.t.classList.toggle('close')

		if (this.e.classList.contains('open')) this.open()
		else this.close()
	}

	open() {
		this.e.style.height = '100vh'
		disableBodyScroll(this.e)
	}

	close() {
		this.e.style.height = null
		enableBodyScroll(this.e)
	}

	scroll() {
		if ( window.scrollY > 1) this.e.classList.add('shadow')
		else this.e.classList.remove('shadow')
	}
}
